export default (theme) => ({
    root: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '& > *': {
            paddingRight: 30,
            '&:last-child': {
                padding: 0,
            },
        },
    },
    field: {
        flex: '1 1 0',
        minWidth: 0,
        '& > div': {
            width: '100%',
        },
    },
    trashIcon: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
        '& > svg': {
            width: '18px',
            height: '18px',
        },
    },
});
